export default __webpack_public_path__ + "static/media/mail-ico.e7b13dc7.svg";